module.exports = __webpack_public_path__ + "static/media/trash-outline.720e54b7.svg";